<template>
    <v-layout justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px">
           <v-card v-if="isInstitution && !officesAreSet" >
               <v-card-text>
                    <v-sheet height="80" class="pa-1">
                        <h1 class="title font-weight-light mt-4">Para crear una agenda primero debes configurar sucursales.</h1>
                    </v-sheet>

               </v-card-text>
               <v-card-actions class="text-center">
                   <v-spacer></v-spacer>
                   <v-btn color="secondary" text @click="hide">Cerrar</v-btn>
                   <v-btn color="primary" text :to="{name: 'panel.provider.branches'}">
                       Configurar sucursales
                   </v-btn>
               </v-card-actions>
           </v-card>

            <v-card v-else>
                <v-card-title class="pb-0">
                    <h1 class="headline">Crear Agenda</h1>
                </v-card-title>
                <v-card-title v-if="currentBranchOffice" class="py-0">
                    <v-icon size="16" color="secondary">fas fa-building</v-icon>
                    <p  class="caption mb-0 ml-1">{{currentBranchOffice.name}}</p>
                </v-card-title>

                <v-divider class="mt-3"></v-divider>


                <v-card-text>
                    <v-form v-model="valid">
                        <v-container pa-0>
                            <v-layout wrap>
                                <template v-if="isInstitution">
                                    <v-flex xs12 >
                                        <specialist-picker
                                                ref="specialistPicker"
                                                :value="specialist"
                                                :auto-default="false"
                                                label="Seleccionar especialista"
                                                v-on:change="onSpecialistSelect"
                                                :serviceProviderId="currentProvider.id"
                                        />
                                    </v-flex>
                                    <v-flex xs12>
                                        <service-picker
                                                :disabled="!specialist"
                                                :value="service"
                                                :filter-ids="specialist && specialist.services && specialist.services.map(serv => serv.id) || []"
                                                ref="servicePicker"
                                                :only-quotable="false"
                                                label="Seleccionar servicio"
                                                v-on:change="onServiceSelect"
                                                :serviceProviderId="currentProvider.id"
                                        />
                                    </v-flex>
                                </template>


                                <v-flex xs12 v-else>
                                    <service-picker
                                            ref="servicePicker"
                                            :value="service"
                                            :only-quotable="false"
                                            label="Seleccionar servicio"
                                            v-on:change="onServiceSelect"
                                            :serviceProviderId="currentProvider.id"
                                    />
                                </v-flex>

                                <v-flex xs12>
                                    <schedule-config-form
                                        ref="configForm"
                                        interval-start-value="08:00"
                                        interval-end-value="18:00"
                                    />
                                </v-flex>

                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="default" text @click="hide">Cancelar</v-btn>
                    <v-btn color="primary" :disabled="disableSave" :loading="loading" text @click="save">
                        Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>

    import BranchOfficePicker from '@/components/providers/BranchOfficePicker'
    import ServicePicker from '@/components/providers/ServicePicker'
    import SpecialistPicker from '@/components/providers/SpecialistPicker'
    import ScheduleConfigForm from '@/components/providers/schedule/ScheduleConfigForm'

    import {ApiUtils} from '@/utils/ApiUtils'
    import {mapState, mapMutations} from 'vuex'

    export default{
        components: {
            BranchOfficePicker,
            ServicePicker,
            SpecialistPicker,
            ScheduleConfigForm
        },
        mounted(){},
        data(){
            return {
                tab: null,
                loading: false,
                dialog: false,
                valid: false,
                isAdmin: false,
                service: null,
                specialist: null
            }
        },
        methods: {
                ...mapMutations(['showSnackBar']),
            show(){

                var vm = this
                vm.reset()
                vm.dialog = true

                vm.$nextTick(function(){
                    vm.$refs.specialistPicker && vm.$refs.specialistPicker.clear()
                    vm.$refs.servicePicker && vm.$refs.servicePicker.clear()
                    vm.$refs.configForm && vm.$refs.configForm.reset()
                })

            },
            hide(){
                var vm = this
                vm.dialog = false
            },
            onServiceSelect(service){
                var vm = this
                vm.service = service
            },
            onSpecialistSelect(specialist){
                var vm = this
                vm.specialist = specialist
            },
            setDefaults(){
                var vm = this
                vm.reset()
            },
            reset(){
                var vm = this
                vm.service = null
                vm.specialist = null
            },
            async save(){

                var vm = this
                if(vm.loading || !vm.currentProvider || vm.disableSave) return

                if(!vm.$refs.configForm.isValid){
                    vm.showSnackBar('Debes completar los campos obligatorios')
                    return
                }

                var config = vm.$refs.configForm.getScheduleConfig()

                vm.loading = true
                const url = vm.isInstitution ?
                        `provider/${vm.currentProvider.id}/branch-office/${vm.currentBranchOffice.id}/schedule` :
                        `provider/${vm.currentProvider.id}/schedule`

                const response = await ApiUtils.makePost(url, {
                        ...config,
                        service_item_id: vm.service && vm.service.id || null,
                        specialist_id: vm.specialist && vm.specialist.id || null,
                })
                vm.loading = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando guardar')
                    return
                }

                vm.$refs.configForm.reset()

                const json = await response.json()
                vm.$emit('success', json.result.schedule)
                vm.showSnackBar('Agenda creada correctamente')
                vm.reset()
                vm.hide()

            }
        },
        computed: {
                ...mapState(['currentProvider', 'currentBranchOffice']),
            disableSave(){
                const vm = this

                return (vm.isInstitution && (!vm.service || !vm.specialist)) ||
                    (!vm.isInstitution && !vm.service)

            },
            isInstitution(){
                return !!this.currentProvider && !!this.currentProvider.institution
            },
            isReadOnly(){
                return this.user ? true : false
            },
            disabled(){

                var vm = this

                return false

            },
            officesAreSet(){
                var vm = this
                return vm.currentProvider
                        && vm.currentProvider.institution
                        && vm.currentProvider.institution.branch_offices
                        && vm.currentProvider.institution.branch_offices.length > 0
            }
        },
        watch:{
            role(val){},
            user(val){
                this.setDefaults()
            },
            specialist(){
              this.service = null
            },
            tab(val){
                var vm = this
                if(val === 1){
                    /*vm.$refs.specialistPicker.clear()*/
                    vm.specialist = null
                }

                if(val === 0){
                    /*vm.$refs.servicePicker.clear()*/
                    vm.service = null
                }
            }
        }
    }
</script>
